export default {"src":"/_next/static/media/save.847fe210.svg","height":29,"width":29};